// extracted by mini-css-extract-plugin
export default {"onlineConsultation":"n3HkP","contact":"S0IWl","image":"w7BZx"};